import { ContentType } from '@entries/content-types'
import ContentfulBlogArticleAmplificationLink from '@entries/contentful-blog-article-amplification-link'
import ContentfulBlogAuthorAmplificationLink from '@entries/contentful-blog-author-amplification-link'
import ContentfulBlogTagAmplificationLink from '@entries/contentful-blog-tag-amplification-link'
import ContentfulDeprecatedPageAmplificationLink from '@entries/contentful-deprecated-page-amplification-link'
import ContentfulStaticPageAmplificationLink from '@entries/contentful-static-page-amplification-link'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulInternalLinkLink: Utils.EntryFC<
  Queries.ContentfulInternalLinkLinkFragment
> = ({ content: { label, pageRef } }) => (
  <Entry
    content={pageRef}
    mapping={{
      [ContentType.ContentfulBlogArticle]:
        ContentfulBlogArticleAmplificationLink,
      [ContentType.ContentfulBlogAuthor]: ContentfulBlogAuthorAmplificationLink,
      [ContentType.ContentfulBlogTag]: ContentfulBlogTagAmplificationLink,
      [ContentType.ContentfulDeprecatedPage]:
        ContentfulDeprecatedPageAmplificationLink,
      [ContentType.ContentfulStaticPage]: ContentfulStaticPageAmplificationLink,
    }}
  >
    {label}
  </Entry>
)

export const query = graphql`
  fragment ContentfulInternalLinkLink on ContentfulInternalLink {
    ...ContentfulEntry
    label
    pageRef {
      ...ContentfulBlogArticleAmplificationLink
      ...ContentfulBlogAuthorAmplificationLink
      ...ContentfulBlogTagAmplificationLink
      ...ContentfulDeprecatedPageAmplificationLink
      ...ContentfulStaticPageAmplificationLink
    }
  }
`

export default withDisplayName(
  ContentfulInternalLinkLink,
  'ContentfulInternalLinkLink'
)
